import { ReactNode } from 'react';

import { Box, chakra, Flex, VStack } from 'components/uikit';

interface PaymentLayoutProps {
  children: ReactNode;
  headerElement?: ReactNode;
}

export function PaymentLayout({ children, headerElement }: PaymentLayoutProps) {
  return (
    <Flex w='100%' h='100dvh' top={0} background='background'>
      <chakra.main
        flex={1}
        overflowY='auto'
        overscrollBehaviorY='contain'
        sx={{
          WebkitOverflowScrolling: 'touch',
        }}
      >
        {headerElement ? (
          <VStack
            position='fixed'
            w='100%'
            align={['center', 'start']}
            py='16px'
            px='32px'
            gap='16px'
          >
            {headerElement}
          </VStack>
        ) : null}
        <VStack
          position='relative'
          h={['auto', '100%']}
          justify={['center', 'center']}
          minH={['100dvh', '100%']}
          pt={['0', '0']}
          overflow='hidden'
          spacing='0'
        >
          <Box
            position='absolute'
            top='40%'
            left='-30%'
            w='160%'
            h='100px'
            bgGradient='linear(
      100deg,
      transparent 0%,
      rgba(20,160,255,0.35) 30%,
      rgba(20,160,255,0.8) 50%,
      rgba(20,160,255,0.35) 70%,
      transparent 100%
    )'
            transform='rotate(-12deg)'
            filter='blur(40px)'
            zIndex={0}
          />
          {children}
        </VStack>
      </chakra.main>
    </Flex>
  );
}
